// extracted by mini-css-extract-plugin
export default {"wrapper":"adminPanel_wrapper__XUR8a","buttons":"adminPanel_buttons__RZvvC"};